export default __webpack_public_path__ + "public/icons/qality-plus.svg?c08aa0e41baebffbcf5c17706d347fa6";